import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-ebook-section',
    imports: [NgOptimizedImage, CommonModule, RouterModule],
    templateUrl: './ebook-section.component.html',
    styleUrl: './ebook-section.component.scss'
})
export class EbookSectionComponent {

}
